import { __generator } from "tslib";
import { all, take, call, put, takeEvery } from 'redux-saga/effects';
import { request } from '../../../xhr';
import { reduxModuleLoaded, requestTiers, requestTiersSuccess, } from './actions';
function handleFetch() {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: '/tier/user/list',
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, put(requestTiersSuccess(response.results))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function userTiersSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, take(reduxModuleLoaded)];
            case 1:
                _a.sent();
                return [4 /*yield*/, all([
                        takeEvery(requestTiers, handleFetch),
                    ])];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=tierListSaga.js.map